import React from 'react';
import { Bubble, Table, TableColumn } from 'tea-component';

import type { ISourceTableProps } from '../../types';

import './index.scss';

const { selectable, scrollable } = Table.addons;

export default function SourceTable(props: ISourceTableProps) {
  const {
    // 勾选数量达到上限后 禁用状态
    isDisabled,
    disabledMsg,
    hideHeader,
    entityKey,
    title,
    records,
    value,
    onChange,
    entityRenderer,
    isDisabledGames = [],
  } = props;

  // console.log('SourceTable', props);

  const addons = [
    scrollable({
      virtualizedOptions: {
        height: 350,
        itemHeight: 64,
      },
    }),
    selectable({
      all: false,
      rowSelect: true,
      value,
      // onChange,
      onChange: (rowkey, context) => {
        if (!isDisabledGames?.includes(context.recordKey)) {
          onChange(rowkey);
        }
      },
      rowSelectable: (rowkey) => !isDisabledGames?.includes(rowkey),
      render: (cvm) => {
        const isChecked = value?.includes(cvm?.props?.name);
        return (
          <Bubble
            arrowPointAtCenter
            dark
            style={{ maxWidth: 346 }}
            content={(isDisabledGames?.includes(cvm?.props?.name) || (isDisabled && !isChecked)) ? disabledMsg : ''}
          >
            {cvm}
          </Bubble>
        );
      },
    }),
  ];

  const columns: TableColumn<any>[] = [
    {
      key: 'data',
      header: title,
      render: (cvm, rowKey, index) => {
        if (typeof entityRenderer !== 'function') return null;
        return entityRenderer({ cvm, rowKey, index });
      },
    },
  ];

  return (
    <Table
      className="dbi-source-table"
      hideHeader={hideHeader}
      recordKey={entityKey}
      records={records}
      columns={columns}
      addons={addons}
    />
  );
}
